import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  //登录
  {
    path: '/',
    name: '登录',
    component: Login
  },
  {
    path: '/navindex',
    name: 'navindex',
    component: () => import('../views/navindex.vue'),
    children: [
      //首页
      {
        path: '/index',
        name: 'index',
        component: () => import('../views/index.vue'),
      },
      //个人信息
      {
        path: '/personinfo',
        name: 'personinfo',
        component: () => import('../views/personinfo'),
      },
      //通用解析页面
      {
        path: '/Application/:app',
        name: 'generalApp',
        component: () => import('../components/customPagesOne/customPages.vue'),
      },
      //通用解析报表
      {
        path: '/Application/GeneralReport/:reportid',
        name: 'generalReport',
        component: () => import('../components/customPagesOne/customReports/customReports'),
      },
      //系统设置 -- 数据表管理
      {
        path: '/data_management',
        name: 'data_management',
        component: () => import('../components/systemSetting/data_management/data_management'),
      },
      //系统设置 -- 菜单管理
      {
        path: '/menu_management',
        name: 'menu_management',
        component: () => import('../components/systemSetting/menu_management/menu_management'),
      },
      //系统设置 -- 用户管理
      {
        path: '/user_management',
        name: 'user_management',
        component: () => import('../components/systemSetting/user_management/user_management'),
      },
      //系统设置 -- 机构管理
      {
        path: '/dept_management',
        name: 'dept_management',
        component: () => import('../components/systemSetting/dept_management/dept_management'),
      },
      //系统设置 -- 角色管理
      {
        path: '/role_management',
        name: 'role_management',
        component: () => import('../components/systemSetting/role_management/role_management'),
      },
      //系统设置 -- 按钮管理
      {
        path: '/button_configure',
        name: 'button_configure',
        component: () => import('../components/systemSetting/button_configure/button_configure'),
      },
      //系统设置 -- 字典管理
      {
        path: '/dictionaries_management',
        name: 'dictionaries_management',
        component: () => import('../components/systemSetting/dictionaries_management/dictionaries_management'),
      },
      //系统设置 -- 系统管理
      {
        path: '/systemSet',
        name: 'systemset',
        component: () => import('../components/systemSetting/systemset/systemSet'),
      },
      //系统设置 -- 编号管理
      {
        path: '/numbers',
        name: 'numbers',
        component: () => import('../components/systemSetting/numbers/numbers'),
      },
      //流程管理 -- 流程模型
      {
        path: '/flow_management',
        name: 'flow_management',
        component: () => import('../components/flowMange/flow_management/flow_management'),
      },
      //流程管理 -- 流程定义
      {
        path: '/flow_process',
        name: 'flow_process',
        component: () => import('../components/flowMange/flow_process/flow_process'),
      },
      //流程管理 -- 用户组管理
      {
        path: '/usergroup_management',
        name: 'usergroup_management',
        component: () => import('../components/flowMange/usergroup_management/usergroup_management'),
      },
      //应用管理 -- 应用管理
      {
        path: '/application_management',
        name: 'application_management',
        component: () => import('../components/application_management/application_management/application_management'),
      },
      //报表管理 -- 报表配置
      {
        path: '/reports/report',
        name: 'report',
        component: () => import('../components/reports/report/report'),
      },
      //报表管理 -- 报表文件
      {
        path: '/reports/reportfile',
        name: 'reportfile',
        component: () => import('../components/reports/reportfile/reportfile'),
      },
      //报表 -- 单据报表
      {
        path: '/customreportchart',
        name: 'customreportchart',
        component: () => import('../components/customPagesOne/customReports/customreportchart'),
      },
      //系统设置 -- app版本管理
      {
        path: '/appversionmanagement',
        name: 'appversionmanagement',
        component: () => import('../components/appversionmanagement/appversionmanagement'),
      },
      //通用外部链接
      {
        path: '/Application/GeneralLink/:linkid',
        name: 'generalLink',
        component: () =>
          import('../page/linkapp/linkapp'),
      },
      //看板
      {
        path: '/linkapp',
        name: 'linkapp',
        component: () =>
          import('../page/linkapp/linkapp'),
      },
      {
        path: '/linkapp2',
        name: 'linkapp2',
        component: () =>
          import('../page/linkapp/linkapp2'),
      },
      {
        path: '/linkapp3',
        name: 'linkapp3',
        component: () =>
          import('../page/linkapp/linkapp3'),
      },
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
